import * as React from "react";
import { forwardRef } from "react";
const SvgMultiSelectChipsCross = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 15, height: 14, viewBox: "0 0 15 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4.44102 10.0582L7.49923 7M10.5574 3.94179L7.49923 7M7.49923 7L4.44102 3.94179M7.49923 7L10.5574 10.0582", stroke: "#AFB0B1", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgMultiSelectChipsCross);
export { ForwardRef as ReactComponent };
